<template>
  <div id="eqSetting">
    <div class="back">
      <div class="body">
        <div class="bodyback">
          <div style="text-align: left;margin-left: 20px">
            <el-button type="primary" size="small" @click="pullData" style="margin-left: 15px;position: absolute; right: 150px;">
              <i class="el-icon-upload"></i>{{$t('equipmentmanagement.read')}}
            </el-button>
            <el-button type="primary" size="small" @click="refreshData" style="margin-left: 15px;position: absolute;right:50px">
              <i class="el-icon-refresh-right el-icon--left"></i>{{$t('refresh')}}
            </el-button>
          </div>
          <div style="text-align: left;margin-left: 20px;margin: 20px 0 20px 20px;">
            <!-- <span>粉盒名称：</span> -->
            <span style="margin-left: 40px;font-weight:bold;font-size:20px">{{$t('equipmentmanagement.powderCanister')}}1：</span><span v-if="channel1Parameters.length==0">{{$t('nodata')}}</span>
            <div style="margin-top: 10px" >
              <el-row :gutter="24"  >
                <el-col :span="12" style="margin-bottom:10px;" v-for="(item1,index) in channel1Parameters" :key="index">
                  <span style="display:inline-block;width:100px;text-align:right">{{item1.name}}:</span>
                  <el-input v-model="item1.value" style="width:40%;margin-right:10px" v-if="item1.edit == 0" :disabled="true"></el-input>
                  <el-input v-model="item1.value" style="width:40%;margin-right:10px" v-else ></el-input>
                  {{item1.unit}}
                </el-col>
              </el-row>
            </div>

            <span style="margin-left: 40px;font-weight:bold;font-size:20px">{{$t('equipmentmanagement.powderCanister')}}2：</span><span v-if="channel2Parameters.length==0">{{$t('nodata')}}</span>
            <div style="margin-top: 10px" >
              <el-row :gutter="24"  >
                <el-col :span="12" style="margin-bottom:10px" v-for="(item1,index) in channel2Parameters" :key="index">
                 <span style="display:inline-block;width:100px;text-align:right">{{item1.name}}:</span>
                  <el-input v-model="item1.value" style="width:40%;margin-right:10px" v-if="item1.edit == 0" :disabled="true"></el-input>
                  <el-input v-model="item1.value" style="width:40%;margin-right:10px" v-else ></el-input>
                  {{item1.unit}}
                </el-col>
              </el-row>
            </div>

            <span style="margin-left: 40px;font-weight:bold;font-size:20px">{{$t('equipmentmanagement.powderCanister')}}3：</span><span v-if="channel3Parameters.length==0">{{$t('nodata')}}</span>
            <div style="margin-top: 10px" >
              <el-row :gutter="24"  >
                <el-col :span="12" style="margin-bottom:10px" v-for="(item1,index) in channel3Parameters" :key="index">
                 <span style="display:inline-block;width:100px;text-align:right">{{item1.name}}:</span>
                  <el-input v-model="item1.value" style="width:40%;margin-right:10px" v-if="item1.edit == 0" :disabled="true"></el-input>
                  <el-input v-model="item1.value" style="width:40%;margin-right:10px" v-else ></el-input>
                  {{item1.unit}}
                </el-col>
              </el-row>
            </div>

            <span style="margin-left: 40px;font-weight:bold;font-size:20px">{{$t('equipmentmanagement.powderCanister')}}4：</span><span v-if="channel4Parameters.length==0">{{$t('nodata')}}</span>
            <div style="margin-top: 10px" >
              <el-row :gutter="24"  >
                <el-col :span="12" style="margin-bottom:10px" v-for="(item1,index) in channel4Parameters" :key="index">
                  <span style="display:inline-block;width:100px;text-align:right">{{item1.name}}:</span>
                  <el-input v-model="item1.value" style="width:40%;margin-right:10px" v-if="item1.edit == 0" :disabled="true"></el-input>
                  <el-input v-model="item1.value" style="width:40%;margin-right:10px" v-else ></el-input>
                  {{item1.unit}}
                </el-col>
              </el-row>
            </div>
          </div>
          <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;" @click="updatePowder">{{$t('confirmModification')}}</el-button>
          <div v-if="isCurrentData==2" class="bodyback">
            <div class="c1" ></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props:
    ['initvalue']
  ,
  name:"EquipmentButtomConfig",
  data() {
    return {
      isCurrentData:1,// 是否是当前数据1是2不是
      allvisible:false,
      isFree:true,
      allpowder:[],
      selectedpowder:[],
      powderindex:-1,
      powderid:-1,
      drinks:[
        [{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null}],
        [{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null}],
        [{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null}],
        [{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null},{cupquantity:null,price:1.00,cup:null}]
      ],
      cupvisible:false,
      postData: {
        keyConfigPostDatas:[],
        equipment_ID:0
      },
      cupid:-1,
      cupquantity: 1,
      cupindex1:-1,
      cupindex2:-1,
      BtnConfigList:[],
      price:'0.00',
      totalBtnConfigCount:0,
      channel1Parameters:[],
      channel2Parameters:[],
      channel3Parameters:[],
      channel4Parameters:[],
    }
  },
  mounted() {
    this.init1()
  },
  methods:{
    init1(){
      return   this.$httpservice.get("api/Equipment/GetCheckParameter?equipmentId="+this.initvalue.id).then(res=>{
        this.allpowder = res.body.data
        this.channel1Parameters=new Array();
        this.channel2Parameters=new Array();
        this.channel3Parameters=new Array();
        this.channel4Parameters=new Array();
        this.allpowder.forEach(e=>{
              switch(e.checkChannelSort){
                case 1:
                  this.channel1Parameters.push(e);
                break
                case 2:
                  this.channel2Parameters.push(e);
                break
                case 3:
                  this.channel3Parameters.push(e);
                break
                case 4:
                  this.channel4Parameters.push(e);
                break
              }
        });
        this.$message({
              message: this.$t('equipmentmanagement.refreshSuccessfully'),
                type: 'success'
        });
      })
    },
    refreshData(){
      this.init1();
    },
    pullData(){
      let that = this;
      this.$httpservice.get("api/EquipmentOperation/ReadEquipmentCheckParameter?equipmentId="+that.initvalue.id).then(
        function (data) {
          if(data.body.code=="200"){
            that.$message({
              message: that.$t('equipmentmanagement.readingSuccessfully')+"！",
                type: 'success'
            });
            that.init1()
          }else{
            that.$message({
              message: data.body.msg,
              type: 'warning'
            });
          }
        },
        function (data) {
                let statusCode = data.status;
                that.$message({
                    message: that.$t('queryFailedStatusCode')+statusCode,
                    type: 'warning'
                });
            }
          );
    },
    //值修改
    updatePowder(){
      let putData = new Object();
      putData.dtuNo = this.initvalue.dtuNumber;
      putData.checkParameters = this.channel1Parameters.concat(this.channel2Parameters,this.channel3Parameters,this.channel4Parameters)
        this.$httpservice.post("api/Equipment/UploadCheckParameter",putData).then(res=>{
        if(res.body.code = "200"){
            this.$message({
              message: "修改成功",
              type: 'success'
            });
            this.channel1Parameters = []
            this.channel2Parameters = []
            this.channel3Parameters = []
            this.channel4Parameters = []

            this.init1();
            this.$httpservice.get("api/EquipmentOperation/PushEquipmentCheckParameter?equipmentId="+this.initvalue.id).then(res=>{
              if(res.body.code = "200"){
                  this.$message({
                    message: this.$t('equipmentmanagement.commandIssuedSuccessfully'),
                    type: 'success'
                  });
              }
              else{
                  this.$message({
                    message: data.body.msg,
                    type: 'danger'
                  });
              }
            })
        }
        else{
            this.$message({
              message: data.body.msg,
              type: 'danger'
            });
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
#eqSetting{
  .back{
    padding: 20px;
    background: url("../../assets/images/equipment/background_pay.jpg");
    background-size: 100% 100%;
    text-align: center;
  }

  .body{
    display: inline-block;
    width: 60%;
    input{
      .el-input__inner{
        text-align: center!important;
      }
    }
  }
  .c1{
    float: left;
    width: 25%;
    text-align: center;
  }
  .c2{
    float: left;
    width: 20%;
    text-align: center;
    position: relative;
    margin-bottom: 20px;
  }

  .c1 img,.c2 img{
    width: 100px;
  }
  .cname{
    display: inline-block;
    width: 110px;
    line-height: 25px;
    color: #2e2115;
    background-size: 100% 100%;
    font-size: 12px;
  }
  .cnameyuan{
    margin-top: 10px;
    display: inline-block;
    width: 70px;
    font-size: 12px;
    height: 25px!important;
  }
  .powderlist{
    overflow: hidden;
    max-height: 500px;
    overflow-y: auto;
  }
  .checked{
    position: absolute;
    left: 20px;
    top: 0px;
    width: 20px!important;
    height: 20px!important;
  }
  .checked2{
    position: absolute;
    right: -10px;
    top: 5px;
    width: 20px!important;
    height: 20px!important;
  }
  .bodyback{
    padding: 20px 0;
    background-color: #f7ebe1;
    overflow: hidden;
    height: 900px;
    overflow-y:scroll;
  }

  .drinkback{
    width: 100px;
    height: 100px;
    /* margin-bottom: 20px; */
    display: inline-block;
    cursor: pointer;
  }
  .noneback{
    background-size: 100% 100%;
  }
  .q1back{
    background: url("../../assets/images/equipment/background_normal.png");
    background-size: 100% 100%;
  }
  .q2back{
    background: url("../../assets/images/equipment/background_bold.png");
    background-size: 100% 100%;
  }
  .q3back{
    background: url("../../assets/images/equipment/background_more_bold.png");
    background-size: 100% 100%;
  }
  .quantity{
    display: inline-block;
    line-height: 30px;
    vertical-align: top;
    margin-right: 20px;
    width: 60px;
    text-align: center;
    background-size: 100% 100% !important;
    color: #fff;
    cursor: pointer;
    position: relative;
  }
  .q1{
    background: url("../../assets/images/equipment/background_normal.png");
  }
  .q2{
    background: url("../../assets/images/equipment/background_bold.png");
  }
  .q3{
    background: url("../../assets/images/equipment/background_more_bold.png");
  }
  .dinkpic{
    display: inline-block;
    width: 80px!important;
    height: 80px!important;
    display: inline-block;
    margin-top: 10px;
  }

  .nopic{
    display: inline-block;
    width: 50px!important;
    height: 50px!important;
    display: inline-block;
    margin-top: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/EquipmentPowderCheck.vue